export const TeamInfo = [

  {
    designation: "Faculty Coordinator",
    about:
      "The Faculty Incharge leads the team in the right direction, disseminates and impart knowledge and assists students with applying the knowledge.",
    id: 1,
    member: [
      {
        head: [
          {
            name: "Dr. Smitha S kumar",
            post: "Faculty Coordinator",
            photo: "Image/Sumitra S Maam.jpeg",
          },
        ],
        coord: [],
      },
    ],
  },

  {
    designation: "CORE TEAM",
    about:
      "Our Core Team, which is the heart and soul of Promethean, is made up of the brightest students. It is not easy to lead a large group of people, yet they make it out to be simple.",
    id: 2,
    member: [
      {
        head: [
          {
            name:"T Naresh",
            post:"Chapter Head",
            photo:"Image/NARESH.jpg"
          },

          {
            name: "Shreyash Marathe",
            post: "Chairperson",
            photo: "Image/Shreyash_CP.jpeg",
          },
         
          {
            name: "Adhira Digraskar",
            post: "Secretary",
            photo: "Image/adhira_marketing cord.png",
          },
         {
            name: "Vrushabh Shirke",
            post: "Treasurer",
            photo: "Image/VR.jpg",
          },
         
        ],
        coord: [
          {
            name: "Tanisha Kasliwal",
            post: "Vice Chairperson",
            photo: "Image/Tanisha.jpg",
          },
          {
            name: "Gaganraj Singh",
            post: "Joint Secretary",
            photo: "Image/gaganraj.jpg",
          },
          {
            name: "Shreya Yadav",
            post: "Joint Secretary",
            photo: "Image/ShreyaY.jpg",
          },
          {
            name: "Akanksha Shinde",
            post: "Joint Treasurer",
            photo: "Image/Akansha.jpg",
          },
        ],
      },
    ],
  },
 
  {
    designation: "TECHNICAL TEAM",
    about:
      "Using various technologies to create and update websites and applications. Exhibiting leadership skills and staying up to date on the latest innovations.",
    id: 3,
    member: [
      {
        head: [
          {
            name: "Trushal Pal",
            post: "Head",
            photo: "Image/Trushal.jpg",
          },
          // {
          //   name: "Vaishnavi Pradhan",
          //   post: "Head",
          //   photo: "Image/VaishnaviP.jpg",
          // },
        ],
        coord: [
          {
            name: "Gaurav Yadav",
            post: "Coordinator",
            photo: "Image/GR.jpeg",
          },
          {
            name: "Krishang Javalkar",
            post: "Coordinator",
            photo: "Image/KR.jpeg",
          },
          {
            name: "Shubronil Chottoraj",
            post: "Coordinator",
            photo: "Image/SH.jpeg",
          },
        ],
      },
    ],
  },
  {
    designation: "CREATIVE AND DESIGN TEAM",
    about:
      "Creating innovative posts that will amaze everyone with their vibrant, appealing, and instructive content. They are creative and hardworking individuals that have a real interest in and ability for design.",
    id: 4,
    member: [
      {
        head: [
          {
            name: "Sakshi Khedkar",
            post: "Head",
            photo: "Image/Sakshi.jpg",
          },
        ],
        coord: [
          {
            name: "Chinmayee Mhatre",
            post: "Coordinator",
            photo: "Image/CH.jpeg",
          },
          {
            name: "Akshata Sonsurkar",
            post: "Coordinator",
            photo: "Image/AK.jpeg",
          },
           {
            name: "Ananya Kadam",
            post: "Coordinator",
            photo: "Image/ANA.jpeg",
          },
          {
            name: "Arvind Mudaliar",
            post: "Coordinator",
            photo: "Image/AR.jpeg",
          },
          {
            name: "Vinay Sawant",
            post: "Coordinator",
            photo: "Image/VIN.jpeg",
          },
           {
            name: "Soumya Marathe",
            post: "Coordinator",
            photo: "Image/SAU.jpeg",
          },
        ],
      },
    ],
  },
  {
    designation: "MARKETING TEAM",
    about:
      "The Marketing team makes the events a tremendous success by recruiting sponsors and pushing students to participate as much as possible.",
    id: 5,
    member: [
      {
        head: [
          {
            name: "Gaganraj Singh",
            post: "Head",
            photo: "Image/gaganraj.jpg",
          },
        ],
        coord: [
          {
            name: "Ansh Mohan",
            post: "Coordinator",
            photo: "Image/AN.jpeg",
          },
          {
            name: "Priyanshu Katakwar",
            post: "Coordinator",
            photo: "Image/PR.jpeg",
          },
          // {
          //   // name: "Piyush Goilkar",
          //   post: "Coordinator",
          //   photo: "Image/piyush.jpg",
          // },
        ],
      },
    ],
  },
  {
    designation: "PUBLIC RELATION TEAM",
    about:
      "It is solely responsible for all external communication from the institute. It aims to position and popularize the Promethean on a variety of platforms.",
    id: 6,
    member: [
      {
        head: [
          {
            name: "Anushka Jha",
            post: "Mentor",
            photo: "Image/Anushka_PRMentor.jpeg",
          },
          {
            name: "Chitrakshi Palav",
            post: "Head",
            photo: "Image/Chitrakshi.jpg",
          },
        ],
        coord: [
          {
            name: "Shweta Pradeep",
            post: "Coordinator",
            photo: "Image/SHW.jpeg",
          },
          {
            name: "Prranjal Sankhe",
            post: "Coordinator",
            photo: "Image/PR.jpeg",
          },
        ],
      },
    ],
  },

  {
    designation: "PUBLICITY & SOCIAL MEDIA TEAM",
    about:
      "The team is in charge of gathering, illustrating, and disseminating important information to students.",
    id: 7,
    member: [
      {
        head: [
          {
            name: "Sarthak Patil",
            post: "Head",
            photo: "Image/sarthak.jpg",
          },
          // {
          //   name: "Renu Khade",
          //   post: "Head",
          //   photo: "Image/RenuKhade.jpg",
          // },
         
        ],
        coord: [
          {
            name: "Rajita Shetty",
            post: "Coordinator",
            photo: "Image/RAJ.jpeg",
          },
          {
            name: "Vishnu Vardhan",
            post: "Coordinator",
            photo: "Image/VIS.jpeg",
          },
          {
            name: "Meet Bhoir",
            post: "Coordinator",
            photo: "Image/ME.jpeg",
          },
          {
            name: "Adya Poojari",
            post: "Coordinator",
            photo: "Image/AD.jpeg",
          },
          {
            name: "Jayyant Argade",
            post: "Coordinator",
            photo: "Image/JA.jpeg",
          },
          {
            name: "Nimish Devkar",
            post: "Coordinator",
            photo: "Image/NI.jpeg",
          },
        ],
      },
    ],
  },

  // {
  //   designation: "CREATIVE TEAM",
  //   about:
  //     "They have established their benchmark by working together to achieve a specific goal. Using their creativity, they make the events as appealing as possible. ",
  //   id: 8,
  //   member: [
  //     {
  //       head: [
  //         {
  //           name: "Rutuja Wagh",
  //           post: "Head",
  //           photo: "Image/rutuja_creative cord.jpg",
  //         },
         
  //       ],
  //       coord: [
  //         {
  //           name: "Shreya Yadav",
  //           post: "Coordinator",
  //           photo: "Image/ShreyaY.jpg",
  //         },
  //         {
  //           name: "Akansha Shinde",
  //           post: "Coordinator",
  //           photo: "Image/Akansha.jpg",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   designation: "SOCIAL MEDIA TEAM",
  //   about:
  //     "Creating visually appealing posts with well-written descriptions. Enhancing Promethean’s  internet presence through promoting activities and keeping students updated about contemporary affairs.",
  //   id: 9,
  //   member: [
  //     {
  //       head: [
  //         {
  //           name: "Snehal Surve",
  //           post: "Head",
  //           photo: "Image/SnehalSurve.jpg",
  //         },
  //         {
  //           name:"Adithya Dogra",
  //           post:"CDS Head",
  //           photo:"Image/adhityaDogra.jpg",
  //         },
  //       ],
  //       coord: [
  //         {
  //           name: "Chinmay Rane",
  //           post: "Coordinator",
  //           photo: "Image/Chinmay.jpg",
  //         },
  //         {
  //           name: "Mitesh Naik",
  //           post: "Coordinator",
  //           photo: "Image/Mitesh.jpg",
  //         },
  //         {
  //           name: "Rushika Poojari",
  //           post: "Coordinator",
  //           photo: "Image/Rushika.jpg",
  //         },
  //       ],
  //     },
  //   ],
  // },
  ];